module.exports = __webpack_public_path__ + "media/recipes/9-e07d49af.png";